import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
export const setTitleContainerProperties = (properties) => {
    return {
        type: MultichainActionType.SET_TITLE_PROPERTIES,
        payload: properties,
    };
};
export const resetTitleContainerProperties = () => {
    return {
        type: MultichainActionType.SET_TITLE_PROPERTIES,
        payload: { title: '' },
    };
};
